// @flow
import * as React from 'react';
import { connect } from 'react-redux';

import type { MapStateToProps } from 'react-redux';

import Indication from '../ui/indication.js';
import CalendarNav from './calendar.nav.js';
import Breadcrumbs from '../breadcrumbs/breadcrumbs.js';
import CalendarHints from './calendar.hints.js';
import { selectUIMessages } from './calendar.selectors.js';

import type { UIState } from '../ui/ui.types.js';
import { isActivityTypeColorSchemeApplied } from './calendar.model';
import ActivityTypeHints from './activity-types/activity-type-hints';

type OwnProps = {|
  children: React.Node,
  showAgenda?: boolean,
  dispatchView?: boolean,
  filterForm?: {
    id: string,
    timezone: string
  },
  customHandleDateChange: () => void
|};

type MappedState = {|
  UI: UIState,
  URL: URL
|};

type Props = {|
  ...OwnProps,
  ...MappedState
|};

class CalendarDayScreen extends React.Component<Props> {
  componentWillReceiveProps(nextProps) {
    if (this.props.UI.modals.FULLSCREEN !== nextProps.UI.modals.FULLSCREEN) {
      if (nextProps.UI.modals.FULLSCREEN) {
        window.document.body.classList.add('calendar-fullscreen');
      } else {
        window.document.body.classList.remove('calendar-fullscreen');
      }
    }
  }

  shouldComponentUpdate(nextProps) {
    const { UI, isActivityTypeColorSchemeEnabled, dispatchView } = this.props;

    if (dispatchView) {
      return true;
    }

    return (
      UI.messages !== nextProps.UI.messages ||
      isActivityTypeColorSchemeEnabled !== nextProps.isActivityTypeColorSchemeEnabled
    );
  }

  render() {
    const {
      UIMessages,
      isActivityTypeColorSchemeEnabled,
      activityTypes,
      customHandleDateChange,
      dispatchView,
      organization,
      organizations,
      showAgenda = true,
      filterForm
    } = this.props;

    const enableTrackFlight =
      organization && organization.organizationSettings.enableTrackFlight === '1';

    return (
      <div>
        <Indication className="filter-indicator" messages={UIMessages} closable />
        <Breadcrumbs />
        <CalendarNav
          customFilterForm={filterForm}
          dispatchView={dispatchView}
          customHandleDateChange={customHandleDateChange}
        />
        {this.props.children}
        {showAgenda &&
          (isActivityTypeColorSchemeEnabled && organization && organization.id ? (
            <ActivityTypeHints
              types={activityTypes}
              organizations={organizations}
              currentOrganizationID={organization.id}
            />
          ) : (
            <CalendarHints enableTrackFlight={enableTrackFlight} />
          ))}
      </div>
    );
  }
}

const msgSelector = selectUIMessages();

const mapStateToProps: MapStateToProps<ReduxState, OwnProps, MappedState> = state => ({
  UIMessages: msgSelector(state),
  UI: state.UI,
  URL: state.URL,
  isActivityTypeColorSchemeEnabled: isActivityTypeColorSchemeApplied(
    state.filterForm && state.userFilters[state.filterForm.id],
    state.URL,
    state.activeActivityTypesList
  ),
  activityTypes: state.activityTypes,
  organization: state.organization,
  organizations: state.organizations
});

export default connect(
  mapStateToProps,
  {}
)(CalendarDayScreen);
